import { render, staticRenderFns } from "./Barcode.vue?vue&type=template&id=a7fd2e64&scoped=true"
import script from "./Barcode.vue?vue&type=script&lang=ts"
export * from "./Barcode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fd2e64",
  null
  
)

export default component.exports